<template>
  <el-popover
    placement="top"
    width="265"
    trigger="click"
    v-model="showWeekdayPopover">
    <div v-if="showWeekdayPopover" class="d-flex">
      <div style="display: flex;">
        <el-button
          v-for="text in weekdays"
          :key="'quick-time-'+text"
          size="mini"
          class="mr-1 ml-0 px-2"
          @click="onQuickSetDuration(text)">
          {{text}}
        </el-button>
      </div>
    </div>
    <span slot="reference" v-if="weekday !== undefined" class="weekday-quick-settings-text" >
      <slot v-bind:weekday="weekday" v-bind:value="value">
        {{ value }}
      </slot>
    </span>
  </el-popover>
</template>

<script>
const weekdays_en = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
// TODO: localize

export default {
  props: {
    value: {
      type: String
    },
    updateOnSave: {
      default: true
    },
  },
  data: () => ({
    weekday: 0,
    showWeekdayPopover: false,
    weekdays: weekdays_en,
  }),
  created() {
    this.weekday = isNaN(this.value) ? 0 : this.value;
  },
  watch: {
    value(value) {
      this.weekday = this.value;
    },
    weekday(value) {
      if ( !this.updateOnSave ) {
        this.$emit('input', value);
      }
    },
  },
  methods: {
    onQuickSetDuration(value) {
      this.showWeekdayPopover = false;
      if ( value < 0 ) {
        this.$emit('custom')
        return;
      }
      if ( this.updateOnSave ) {
        this.$emit('input', value);
      }
      this.$emit('save', value);
    },
  }
}
</script>

<style>
.weekday-quick-settings-text:hover {
  text-decoration: underline;
  text-decoration-style: double;
  text-decoration-color: #409eff;
}
.weekday-quick-settings-text {
  cursor: pointer;
}
</style>
